export default "/images/vendor/flag-icon-css/flags/1x1/im.svg?d637f63b68f97839a27b37c34f1af1a1";